import { createSlice } from "@reduxjs/toolkit";

import { getProgramData } from "../../services/api/robot";

import { novDataDailyReport } from "../../libs/utils";

const reportSlice = createSlice({
  name: "reports",
  initialState: {
    fetching: false,
    fetchingError: null,
  },

  reducers: {
    fetchListRequest: (state) => ({
      ...state,
      fetching: true,
      fetchingError: null,
    }),

    fetchListFailure: (state, action) => ({
      ...state,
      fetching: false,
      fetchingError: action.error,
    }),

    fetchListSuccess: (state, action) => ({
      ...state,
      fetching: false,
      fetchingError: null,
      reports: action.payload.reports,
    }),

    fetchRequest: (state) => ({
      ...state,
      fetching: true,
      fetchingError: null,
    }),

    fetchFailure: (state, action) => ({
      ...state,
      fetching: false,
      fetchingError: action.error,
    }),

    fetchSuccess: (state, action) => ({
      ...state,
      fetching: false,
      fetchingError: null,
    }),
  },
});

export const {
  fetchListRequest,
  fetchListFailure,
  fetchListSuccess,
  fetchRequest,
  fetchFailure,
  fetchSuccess,
} = reportSlice.actions;

export default reportSlice.reducer;

export const getRobotReports = (id) => async (dispatch) => {
  try {
    dispatch(fetchListRequest());

    const { data } = await getProgramData(id === "171" ? 1 : id, "daily_reports");

    const reports = novDataDailyReport(data);
    dispatch(fetchListSuccess({ reports }));
  } catch (err) {
    dispatch(fetchListFailure(err.toString()));
  }
};
